import store from '@/store';
import IrrigationBase from '@/modules/irrigation/components/IrrigationBase';
import IrrigationDashboard from '@/modules/irrigation/views/Dashboard';
import IrrigationDetailBase from '@/modules/irrigation/components/IrrigationDetailBase';
import Overview from '@/modules/irrigation/views/Overview';
import ActionTracker from '@/modules/projects/views/ActionTracker';
import SUBDTiers from '@/modules/irrigation/views/SUBDTiers';
import ProjectEstimates from '@/modules/irrigation/components/ProjectEstimates';
import Controllers from '@/modules/irrigation/views/Controllers';
import ProjectInvoices from '@/modules/projects/views/ProjectInvoices';
import ProjectWOs from '@/modules/projects/views/ProjectWOs';
import TimesheetDetails from '@/modules/projects/views/timesheetDetails/TimesheetDetails';
import IrrigationReports from '../views/reports/Systems';

const routes = [
  {
    path: '/irrigation/',
    component: IrrigationBase,
    meta: { appKey: 'irrigationprojects' },
    children: [
      {
        path: 'dashboard',
        component: IrrigationDashboard,
      },
      {
        path: 'dashboard',
        component: IrrigationDashboard,
        name: 'IrrigationDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'controllers',
        component: Controllers,
        name: 'Controllers',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'irrigation-reports',
        component: IrrigationReports,
        name: 'IrrigationReports',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'subd-tiers',
        component: SUBDTiers,
        name: 'SUBDTiers',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'details/:id/',
        component: IrrigationDetailBase,
        children: [
          {
            path: 'overview',
            component: Overview,
            name: 'IrrigationOverview'
          },
          {
            path: 'invoices',
            name: 'IrrigationInvoices',
            component: ProjectInvoices
          },
          {
            path: 'work-orders',
            name: 'WorkOrders',
            component: ProjectWOs
          },
          {
            path: 'project-estimates',
            component: ProjectEstimates,
            name: 'IrrigationEstimates'
          },
          {
            path: 'timesheet-details',
            component: TimesheetDetails,
            name: 'IrrigationTimesheetDetails',
          },
          {
            path: 'action-tracker',
            name: 'IrrigationActionTracker',
            component: ActionTracker
          }
        ]
      }
    ]
  }
]

export default routes
